import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class ParentStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control?.invalid && control.parent?.dirty);
    const invalidParent = !!(control?.parent && control.parent.invalid && control.parent.dirty);

    return invalidCtrl || invalidParent;
  }
}
